<template>
  <div class="text-start bg-white pt-3 border rounded shadow-sm text-start p-4">
    <div class="mt-2">
      <div class="">
        <label class="block text-sm ">Organization name<span class="text-red-700">*</span></label>
        <input aria-label="Organization name" type="text" required v-model="name"
               class="appearance-none bg-transparent rounded-md relative block w-full px-3 py-2 border
                                       border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none
                                       focus:shadow-outline-teal focus:border-teal-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="Organization name"/>
      </div>
      <div class="my-3">
        <label class="block text-sm leading-5 ">Address</label>
        <input aria-label="Password" name="password" type="text" required v-model="address"
               class="appearance-none bg-transparent rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-teal focus:border-teal-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="Address"/>
      </div>
      <div class="flex my-3 justify-between">
        <div class="w-full mr-2">
          <label class="block text-sm leading-5 ">Phone number</label>
          <input aria-label="Password" name="phone_number" type="text" v-model="phone_number"
                 class="appearance-none bg-transparent rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-teal focus:border-teal-300 focus:z-10 sm:text-sm sm:leading-5"
                 placeholder="Phone number"/>
        </div>
        <div class="w-full ml-2">
          <label class="block text-sm leading-5 ">Email</label>
          <input aria-label="Password" name="email" type="email" v-model="email"
                 class="appearance-none bg-transparent rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-teal focus:border-teal-300 focus:z-10 sm:text-sm sm:leading-5"
                 placeholder="Email"/>
        </div>
      </div>
      <div class="mt-2">
        <label class="block text-sm leading-5 ">Description</label>
        <textarea name="more_info" type="email" v-model="more_info"
                  class="appearance-none bg-transparent rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-teal focus:border-teal-300 focus:z-10 sm:text-sm sm:leading-5"
                  placeholder="Organization description"></textarea>
      </div>
      <div class="mt-6 text-right">
        <button type="submit" v-if="organization == null || organization.im_admin"
                v-on:click="updateOrganization"
                class="py-2 px-4 bg-teal-500 hover:bg-teal-700 font-semibold text-white hover:border-transparent rounded">
          {{ organization == null ? "Create" : "Update" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "../services/Utils";

export default {
  name: "OrganizationSettingsComponent",
  props: {
    orgId: String,
    action: String
  },
  data() {
    return {
      organization: null,
      name: null,
      phone_number: null,
      address: null,
      email: null,
      more_info: null,
      loading: false,
      errors: []
    }
  },
  mounted() {
    if (this.orgId != null)
      this.getOrganization()
  },
  watch: {
    organization: function (organization) {
      if (organization == null) return;
      this.name = organization.name;
      this.address = organization.address;
      this.email = organization.email_address;
      this.more_info = organization.more_info;
      this.phone_number = organization.phone_number;
    },
    errors: function (errors) {
      this.$root.$emit("alert_error", errors);
    }
  },
  methods: {
    getOrganization() {
      this.axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations/' + this.orgId)
          .then((result) => {
            this.organization = result.data.data.organization;
          })
          .catch((error) => {
            this.$root.$emit('error', error);
            this.errors.push("An error occurred while connecting to server")
          }).finally(() => {
      });
    },
    updateOrganization() {
      this.loading = true;
      this.errors = [];
      if (this.name == null || this.name === '')
        this.errors.push("Name field is required.");
      if (this.errors.length > 0) {
        this.loading = false;
        return;
      }

      const body = {
        name: this.name,
        address: this.address,
        more_info: this.more_info,
        phone_number: this.phone_number,
        email: this.email
      };

      let request = this.organization == null
          ? this.axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations', body)
          : this.axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations/' + this.orgId, body);

      request.then((result) => {
        this.$root.$emit("alert_success", [result.data.data.message]);
        this.organization = result.data.data.organization;
      }).catch((error) => {
        if (error.response != null && error.response.status === 422)
          this.errors = Utils.processError(error.response.data);
        else
          this.errors.push("An error occurred while connecting to server")
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>